/* src/app/modules/portal/components/planned-activities-page/planned-activities-page.component.scss */
:host {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
}
sh-card {
  overflow: hidden;
  height: 100%;
}
sh-table-cell sh-icon {
  display: inline;
  position: absolute;
  margin-left: 100px;
}
.menu {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
}
.container {
  display: flex;
  flex-direction: column;
}
.reset-filters {
  margin: 10px;
}
sh-table-row:not(:first-child) {
  margin-bottom: 3px;
}
sh-table-row[color=yellow] {
  border-left: 4px solid #ffd201;
}
sh-table-row[color=green] {
  border-left: 4px solid #009a38;
}
sh-table-row[color=red] {
  border-left: 4px solid #e7001d;
}
sh-table-cell {
  align-items: baseline;
}
sh-table-cell span {
  margin-top: -5px;
}
[screen-phone] :host-context .menu {
  margin-top: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  gap: 1rem;
}
[screen-phone] :host-context .menu > * {
  width: calc(50% - 0.5rem);
}
[screen-phone] :host-context .menu sh-search {
  width: calc(100% - 100px);
}
[screen-phone] :host-context .menu #refresh {
  width: initial;
}
[screen-phone] :host-context .menu .reset-filters {
  display: none;
}
#only-planned-activities {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
.reset-icon {
  cursor: pointer;
}
/*# sourceMappingURL=planned-activities-page.component.css.map */
